import Fading from "./Fading";
export * from "./Fading";
export default Fading;
